module.exports = __webpack_public_path__ + "static/media/video-bg-light-negate.47acaba8.mp4";